const config = {
  // In production, this should be set via REACT_APP_API_URL environment variable
  // Example: https://aicaseinterview-new-4.onrender.com
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000'
};

export default config; 